import { ApiLinkEntity } from "config/constants"
import { Guid } from "@/types"
import { Document, IGetDocumentDto } from "./Document"
import DocumentCategory, { ReservedDocumentCategoryType } from "./DocumentCategory"

export interface IGetDocumentCategoryWithDocumentsDto {
    entities: IDocumentCategoryWithDocumentsDto[]
}

export interface IDocumentCategoryWithDocumentsDto {
    categoryId: Guid
    categoryName: string
    reservedType?: ReservedDocumentCategoryType | null
    documents: IGetDocumentDto[]
}

export class DocumentCategoryWithDocuments extends DocumentCategory {
    documents: Document[]

    constructor(dto: IDocumentCategoryWithDocumentsDto, { entity, userEmails }: { entity: ApiLinkEntity, userEmails: Record<Guid, string> }) {
        super({
            id: dto.categoryId,
            name: dto.categoryName,
            usageScope: undefined,
            reservedType: dto.reservedType,
        })
        this.documents = dto.documents.map(d => new Document(d, { entity, uploadedByEmail: userEmails[d.uploadedBy] }))
    }
}
